import styled from 'styled-components';

// TR-480: khung iframe Lark scheduler nhúng trong Polaris Modal (size large).
// Full width modal; cao đủ để hiển thị trọn scheduler, không cần mở tab mới.
export const StyledSchedulerFrame = styled.iframe`
  width: 100%;
  height: 70vh;
  min-height: 600px;
  border: 0;
  display: block;
`;
